module.exports = __webpack_public_path__ + "img/verbier-careers.1eea507.jpg";